module.exports = __webpack_public_path__ + "img/circuit-board.a92a067a.svg";